import COUNTRY_URL_PARAMS from "../components/molecules/forms/static/countryURLParams.js";

export default {
    methods: {
        getQueryString(country) {
            const countryParams = country ? COUNTRY_URL_PARAMS[country.toLowerCase()] : null;
            const searchParams = new URLSearchParams(countryParams || {});
            const params = searchParams.toString();
            if (params.length > 0) {
                return "?" + params;
            }
            return "";
        },
    },
};
